import React, { useEffect } from "react";
import FHIR from "fhirclient";
import { useParams } from "react-router-dom";

interface epicLaunchAppProps {
  aiName?: string; // Optional prop for AI name
}

const EpicLaunch: React.FC<epicLaunchAppProps> = ({ aiName }) => {

  useEffect(() => {
    FHIR.oauth2.authorize({
      clientId: "a2a1bd45-3c51-4da9-b5a9-1e4e93dd963c", // Replace with actual client ID
      scope: "patient/*.* user/*.* launch openid fhirUser", // Define necessary scopes
      redirectUri: `https://stage.ehrconnect.healthconnect.systems/healthconnect-epic-ai-summary/NjAyNmNjNTUtYWY2YS00OTk1LWE2YTAtMDVlNTM1ZTA4NTYxLDE3MjQyNzRhODdhMjcxZjViNWI0NzFjMTBhZDU2YjE3YjljOWFkMmQxYWRiMzdlOTNlMDMxZmE4ZDZmNDAzM2I%3D`,
    });
  }, []); // reirecturi to redircet to healthconnect url

  return <div>{/* Optionally show loading or status */}</div>;
};

export default EpicLaunch;
